import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

export function LevReactQueryDevtools() {
	if (import.meta.env.VITE_ENABLE_REACT_QUERY_DEVTOOLS !== 'true') {
		return null;
	}

	return <ReactQueryDevtools buttonPosition='bottom-left' initialIsOpen={false} />;
}
